module.exports = __webpack_public_path__ + "static/media/stefanKroll.b4d71c90.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/images/authorSpotlight/stefanKroll.jpg
// module id = 1592
// module chunks = 1